import classnames from 'classnames/bind';
import { Argument } from 'classnames';

/** 根据原始类名得到css module化处理后的类名 */
type StylesBinder = (...args: Argument[]) => string;

/**
 * 得到将传入{@link Argument 原始类名}映射为CSS模块化处理后类名的绑定函数
 * @param styles 类名映射表（引入*.module.less）：原始类名 -> 模块化处理后类名
 */
export function getStylesBinder(styles: StylesClassNameMap): StylesBinder {
  return classnames.bind(styles);
}
